// Blank-state factories for the v3 Entanglement quote lifecycle, ported from
// tpr/src/helpers.js. Shapes mirror the TPR backend responses.

export const blankLastSavedQuote: any = {
	"dealerID": 0,
	"omniGuid": "",
	"trackingID": "",
	"quoteID": "",
	"eligibilityID": "",
	"eligibilityOutcome": "",
	"preApprovalStatus": "",
	"lastSavedDate": "",
	"vin": "",
	"vsid": "",
	"materialcode": "",
	"batchNumber": "",
	"productionDate": "",
	"inStock": false,
	"driveawayPrice": 0,
	"gfv": 0,
	"nvic": "",
	"model": "",
	"fullDescription": "",
	"tprGuid": ""
};

export const blankUpdateQuote: any = {
	errorResponse: null,
	httpStatusCode: 0,
	failedPost: null,
	success: false,
	failedCorellation: ""
};

export const blankRetrieveQuote: any = {
	"response": {
		"customerDomain": {
			"customer": {
				"trackingId": "",
				"customerId": "",
				"livingSituation": "",
				"propertySituation": true
			},
			"person": {
				"salutation": null,
				"givenName1": "",
				"givenName2": null,
				"surname": "",
				"dateOfBirth": "",
				"maritalStatus": null
			},
			"contactEmailAddress": [
				{
					"email": ""
				}
			],
			"contactTelephone": [
				{
					"telephoneNumber": ""
				}
			],
			"address": [
				{
					"geoCode": 0,
					"streetName": "",
					"subPremise": null,
					"unitNumber": null,
					"streetType": null,
					"streetNumber": "",
					"addressLine1": null,
					"citySuburb": "",
					"stateProvince": "",
					"postZipCode": "",
					"countryCode": "",
					"fullAddress": "",
					"addressPurposeType": null,
					"primaryAddressIndicator": null
				}
			],
			"driversLicence": {
				"licenceType": null,
				"licenceNumber": "",
				"expiryDate": null,
				"state": null,
				"country": ""
			},
			"customerInteraction": {
				"quote": {
					"quoteId": "",
					"originatingQuoteId": null,
					"status": "",
					"createdDate": "",
					"expiryDate": "",
					"eligibilityId": "",
					"eligibilityOutcome": "",
					"salesChannelName": "",
					"borrowerType": "",
					"feeAmount": 0,
					"establishmentFee": 0,
					"ppsrFee": 0,
					"monthlyAccountFee": null,
					"onChargedDealerAgencyFee": 0
				},
				"preApproval": {
					"preApprovalId": null,
					"preApprovalStatus": null,
					"originatedQuoteId": null,
					"preApprovalExpiryDate": null
				}
			},
			"financialDetailRetailFinance": {
				"repaymentFrequency": "",
				"repaymentAmount": 0,
				"regularInstallmentAmount": null,
				"interestRate": 0,
				"comparisonRate": 0,
				"loanTerm": 0,
				"endOfTermOdometerReading": null,
				"financier": "",
				"financeBrand": ""
			},
			"financeAccount": {
				"totalAmountFinanced": 0,
				"balloonAmount": 0,
				"calculatedBalloonAmount": 0,
				"depositAmount": 0
			}
		},
		"dealerDomain": {
			"dealer": {
				"id": 0,
				"metroRural": "",
				"make": "",
				"region": ""
			}
		},
		"productDomain": {
			"product": {
				"productSubCategory": "",
				"productTitle": "",
				"productType": ""
			}
		},
		"vehicleDomain": {
			"vehicle": {
				"vehicleCode": "",
				"vehicleBuildDate": "",
				"estimatedDistance": 0
			},
			"vehicleSpecification": {
				"vehicleYear": "",
				"vehicleMake": "",
				"vehicleModel": "",
				"vehicleModelVariant": "",
				"vehicleImage": ""
			},
			"vehicleCatalogue": {
				"lifeStatus": ""
			},
			"vehiclePrice": {
				"basePrice": 0,
				"priceType": null
			}
		},
		"loanType": 0,
		"financeHeading": "",
		"disclaimer": ""
	},
	"errorResponse": null,
	"httpStatusCode": 0,
	"failedCorellation": "",
	"success": false
};

export const blankUpdateRepayments: any = {
	"alfaFinancialResponse": {
		"customerDomain": {
			"financialDetailRetailFinance": {
				"repaymentAmount": 0,
				"comparisonRate": 0,
				"interestRate": 0,
				"monthlyRepaymentAmount": 0
			},
			"financeAccount": {
				"balloonAmount": 0,
				"calculatedBalloonAmount": 0,
				"maxBalloonAmount": 0,
				"maxDepositAmount": 0,
				"totalAmountFinanced": 0
			},
			"customerInteraction": {
				"quote": {
					"eligibilityId": "",
					"eligibilityOutcome": "",
					"onChargedDealerAgencyFee": 0,
					"establishmentFee": 0,
					"ppsrFee": 0,
					"accountFee": 0
				},
				"preApproval": {
					"preApprovalId": "",
					"preApprovalStatus": "",
					"originatedQuoteId": "",
					"preApprovalExpiryDate": ""
				}
			},
			"additionalOutput": {
				"totalKms": 0,
				"kmsPerYear": 0,
				"disclaimer": "",
				"financeHeading": ""
			}
		}
	},
	// the live API returns additionalOutput at the top level (see tpr/notes.txt
	// sample); the copy under customerDomain above matches tpr's blank shape
	"additionalOutput": {
		"totalKms": 0,
		"kmsPerYear": 0,
		"disclaimer": "",
		"financeHeading": ""
	},
	"errorResponse": null,
	"httpStatusCode": 0,
	"failedCorellation": "",
	"success": false,
	"failedRequest": null
};

export const blankQuoteCreate: any = {
	"createQuoteResponse": {
		"customerDomain": {
			"customer": {
				"trackingId": ""
			},
			"financialDetailRetailFinance": {
				"rateMatrix": []
			}
		},
		"customerInteraction": {
			"quote": {
				"eligibilityId": "",
				"eligibilityOutcome": "",
				"onChargedDealerAgencyFee": 0,
				"establishmentFee": 0,
				"ppsrFee": 0,
				"accountFee": 0
			},
			"preApproval": {
				"preApprovalId": "",
				"preApprovalStatus": "",
				"originatedQuoteId": "",
				"preApprovalExpiryDate": ""
			}
		}
	},
	"compactFinanceMatrixResponse": [],
	"errorResponse": null,
	"httpStatusCode": 0,
	"failedPost": null,
	"success": false,
	"guestRateIdentifier": "",
	"validityDate": "",
	"pegaGuid": "",
	"pegaCaseTracking": ""
};

export const blankForgeRockApp: any = {
	isTokenExpired: false,
	tokens: {
		accessToken: '',
		idToken: '',
		refreshToken: '',
		tokenExpiry: 0
	},
	userState: {
		user: {
			sub: '',
			subname: '',
			anonymousUser: undefined
		}
	},
	formMessage: {
		text: '',
		level: ''
	},
	viewStep: ''
};
